import React from "react";
import api from "../../services/ApiService";
import { Container, Text, Button, Group, Loader } from "@mantine/core";
import GridContainer from "../../components/GridContainer.jsx";
import { useNavigate } from "react-router-dom";
import ApartmentCard from "../../components/ApartmentCard.jsx";
import { useTrans } from "core/index.js";
import { Api_Apartment, Api_GetOwns } from "../../../../constants/SubApi.js";
import getLocalizedField from "services/getLocalizedField.js";

export default function OwnerApartments() {
	const navigate = useNavigate();
	const statusLabels = ["published", "unacceptable", "pending"];
	const [isSelected, setIsSelected] = React.useState([1, 0, 0]);
	const [items, setItems] = React.useState([]);
	const [offset, setOffset] = React.useState(0);
	const limit = 10;
	const [loading, setLoading] = React.useState(false);
	const [initialLoading, setInitialLoading] = React.useState(true);
	const [hasMore, setHasMore] = React.useState(true);
	const { t } = useTrans();
	const getFilters = () => {
		let statusValue = 0;
		if (isSelected[0] === 1) statusValue |= 1;
		if (isSelected[1] === 1) statusValue |= 2;
		if (isSelected[2] === 1) statusValue |= 4;

		return { status: statusValue };
	};

	const loadData = React.useCallback(
		async (refresh = false) => {
			if (loading) return;

			setLoading(true);

			try {
				const currentOffset = refresh ? 0 : offset;

				const filters = getFilters();
				const filterQuery = `&filter=${encodeURIComponent(JSON.stringify(filters))}`;

				const res = await api.get(
					`/${Api_Apartment}/${Api_GetOwns}?offset=${currentOffset}&limit=${limit}${filterQuery}`
				);

				const data = res?.data ?? [];

				if (refresh) {
					setItems(data);
					setOffset(data.length);
					setHasMore(data.length === limit);
				} else {
					setItems((prev) => [...prev, ...data]);
					setOffset(currentOffset + data.length);
					if (data.length < limit) setHasMore(false);
				}
			} catch (err) {
				console.error("Failed to load apartments", err);
			}

			setLoading(false);
			setInitialLoading(false);
		},
		[offset, isSelected, loading]
	);

	React.useEffect(() => {
		loadData(true);
	}, []);

	const onStatusClick = (index) => {
		const next = [...isSelected];
		next[index] = next[index] === 1 ? 0 : 1;
		setIsSelected(next);
	};

	const onScroll = (e) => {
		const target = e.target;
		if (!loading && hasMore) {
			const bottomGap = target.scrollHeight - target.scrollTop - target.clientHeight;
			if (bottomGap < 150) loadData();
		}
	};

	return (
		<Container size="xl" style={{ padding: 12, height: "100vh", overflow: "auto" }} onScroll={onScroll}>
			{" "}
			<Group position="apart" mb="md">
				{" "}
				<Group>
					{statusLabels.map((label, i) => {
						const active = isSelected[i] === 1;
						return (
							<Button
								key={i}
								size="xs"
								style={{
									background: active ? "#1971c2" : "#eee",
									color: active ? "white" : "#1971c2",
								}}
								onClick={() => onStatusClick(i)}
							>
								{t("customApartment." + label)}
							</Button>
						);
					})}

					{/* APPLY FILTERS BUTTON */}
					<Button size="xs" onClick={() => loadData(true)} style={{ background: "#0c7a33", color: "white" }}>
						{t("report.applyFilters")}
					</Button>
				</Group>
			</Group>
			{initialLoading && (
				<div style={{ textAlign: "center", padding: 40 }}>
					<Loader size="lg" />
				</div>
			)}
			{!initialLoading && items.length === 0 && (
				<Text size="lg" align="center" mt="lg">
					{t("messages.noDataFound")}
				</Text>
			)}
			<GridContainer>
				{items.map((apt) => (
					<ApartmentCard
						key={apt.id}
						data={apt}
						image={apt.baseImage}
						title={getLocalizedField(apt, "name")}
						currency={getLocalizedField(apt, "currency_name")}
						price={apt.dailyPrice}
						status={apt.status}
						width={300}
						height={350}
						onClick={() => navigate(`/apartments/owns/${apt.id}`)}
					/>
				))}
			</GridContainer>
			{loading && !initialLoading && (
				<div style={{ textAlign: "center", padding: 20 }}>
					<Loader />
				</div>
			)}
		</Container>
	);
}
